import "@fontsource-variable/geist";
import "./src/styles/global.css";
import React from "react";
import { ReactLenis } from "lenis/react";

export const wrapPageElement = ({ element, props }) => {
  return <ReactLenis root>{element}</ReactLenis>;
};
